import shortid from 'shortid';

const SET_MEDIA_MAPPING = `@ugcMediaOfMember/SET_MEDIA_MAPPING`;

const defaultState = {
    entryIdsMapMediaList: {},
    mediaListByMapId: {}
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_MEDIA_MAPPING: {
            const medias = action.payload ?? [];
            const memberHash = shortid.generate();
            const entryIdsMapMediaList = medias.reduce((obj, { serialNo }) => {
                obj[serialNo] = memberHash;
                return obj;
            }, {});
            return {
                ...state,
                entryIdsMapMediaList: { ...state.entryIdsMapMediaList, ...entryIdsMapMediaList },
                mediaListByMapId: { ...state.mediaListByMapId, [memberHash]: medias }
            };
        }
        default:
            return state;
    }
};

export default reducer;

export function setMediaMapping(medias) {
    return {
        type: SET_MEDIA_MAPPING,
        payload: medias
    };
}
